import React from 'react';
import PropTypes from 'prop-types';
import { Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { find, isEmpty } from 'lodash';

const ColButton = ({
  xs,
  sm,
  md,
  lg,
  xl,
  variant,
  size,
  onClick,
  active,
  disabled,
  type,
  form,
  icon,
  spin,
  spanLabel
}) => {
  return (
    <Col
      as={Button}
      xs={xs}
      sm={find([sm, xs], colSize => colSize > 0)}
      md={find([md, sm, xs], colSize => colSize > 0)}
      lg={find([lg, md, sm, xs], colSize => colSize > 0)}
      xl={find([xl, lg, md, sm, xs], colSize => colSize > 0)}
      variant={variant}
      className="border"
      size={size}
      onClick={onClick}
      active={active}
      disabled={disabled}
      type={type}
      form={form}
    >
      <div className="d-flex d-flex-row align-items-center justify-content-center">
        {!isEmpty(icon) && <FontAwesomeIcon icon={icon} size="lg" spin={spin} />}
        <span className="pl-1 flex-grow-1">{spanLabel}</span>
      </div>
    </Col>
  );
};

ColButton.defaultProps = {
  xs: 12,
  sm: 0,
  md: 0,
  lg: 0,
  xl: 0,
  variant: 'primary',
  size: '',
  active: false,
  disabled: false,
  type: 'button',
  form: '',
  icon: '',
  spin: false
};

ColButton.propTypes = {
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  variant: PropTypes.string,
  size: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  form: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  spin: PropTypes.bool,
  spanLabel: PropTypes.string.isRequired
};

export default ColButton;
